import reConfig from "@/constants/releaseConfig";
import axios from "axios";
import utils from "@/utils/methods";

export default (prefix = reConfig.apiPrefix, header) => {
	process.env.NODE = "";
	let fullPrefix =
		process.env.NODE == "NODE" ? reConfig.remoteOrigin + prefix : prefix;
	let methods = ["get", "post", "del", "put"];
	let result = {};
	methods.forEach(item => {
		result[item] = wrapMethod(item, fullPrefix, header);
	});
	return result;
};

function wrapMethod (methodName, prefix, header) {
	return (url, data = {}) => {
		let fetchUrl = `${prefix}${url}`;
		return new Promise((resolve, reject) => {
			axios({
				method: methodName,
				url: fetchUrl,
				data: header ? data : filterObj(data),
				params: methodName === "get" ? data : {},
				headers: {
					"Content-Type": header || "application/x-www-form-urlencoded"
					// 'accept-encoding':'gzip'
				},
				withCredentials: true,
				crossDomain: true
			})
				.then(res => {
					if (res.data.code == 404) {
						console.log("未授权")
						console.log("request页面")
						let queryObj = utils.getUrlParams(location.search);
						delete queryObj.code;
						delete queryObj.state;
						const par = utils.filterParams(queryObj);
						// 携带scopeMode=base页面使用静默授权
						const scopeMode = queryObj.scopeMode === 'base' ? 'snsapi_base' : 'snsapi_userinfo';
						const href = `${location.protocol}//${location.host.includes('app.yatiku') ? 'inward.yatiku.com' : location.host}${location.pathname}?${par}&reload=1`;
						
						// 如果是微信浏览器就跳授权， 如果不是就不理
						if (navigator.userAgent.toLowerCase().includes("micromessenger")) {
							window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${localStorage.getItem("appId")}&redirect_uri=${encodeURIComponent(href)}&response_type=code&scope=${scopeMode}&state=1#wechat_redirect`);
						}

					}
					resolve(res.data);
				})
				.catch(error => {
					reject(error);
				});
		});
	};
}

function filterObj (value) {
	let errorType = ["null", "undefined", "NaN"];
	let item = "";
	let access_token = localStorage.getItem("access_token") || "";
	value["access_token"] = access_token;
	Object.keys(value).forEach(val => {
		if (errorType.indexOf(value[val]) != -1) value[val] = "";
		item += `${val}=${value[val]}&`;
	});
	return item.substr(0, item.length - 1);
}

function serialize (obj) {
	let str = [];
	let keys = Object.keys(obj);
	if (!keys.length) {
		return "";
	}
	keys.forEach(item => {
		str.push(`${encodeURIComponent(item)}=${encodeURIComponent(obj[item])}`);
	});

	return `?${str.join("&")}`;
}



// WEBPACK FOOTER //
// ./src/utils/request.js